export default __webpack_public_path__ + "static/media/xdc-logo.07f92fcf.png";